<template>
	<div class="groupPackage">
		<back-to :title="productList.title"></back-to>
		<!-- 选择套餐 -->
		<section class="groupPackage-package">
			<div class="groupPackage-package_con">
				<h2>选择套餐</h2>
				<label for="">
					<p v-for="(item,index) in productList.package" :key="index"
						:class="packegeSelectIndex == index? 'groupPackageActive':''" @click="changes(index)">
						{{item.name}}
					</p>
				</label>
			</div>
			<div class="groupPackage-package_con">
				<h2>选择子套餐</h2>
				<label for="">
					<p v-for="(item,index) in productListPackage.gctemplate" :key="index"
						:class="childIndex == index? 'groupPackageActive':''" @click="change(index)"> {{item.title}}</p>
				</label>
			</div>
		</section>
		<!-- 出发日期 -->
		<section class="groupPackage-date">
			<van-calendar title="出发日期" :formatter="formatter" :poppable="false" :show-confirm="false"
				class="choiceDate-calendar" @select="select" :default-date="defaultDate" />
		</section>
		<!-- 选择数量 -->
		<section class="groupPackage-num">
			<h2 class="groupPackage-title">选择数量</h2>
			<div class="groupPackage-num_chosee">
				<span v-for="(item,index) in enrollsList.enrolls" :key="index">
					<label for="">
						<p>
							{{item.enrollName+'(￥'+item.price_01+' 余'+ (enrollsList.remaining - buyNum[index].num) +')'}}
						</p>
					</label>
					<label for="">
						<!-- ,getTotal() -->
						<img src="https://sweetour-pic.obs.myhwclouds.com/order_minus.png" class="type-num-minus"
							@click="sub(index)" />
						<p class="type-num-buynum">{{buyNum[index].num}}</p>
						<img src="https://sweetour-pic.obs.myhwclouds.com/order_plus.png" class="type-num-plus"
							@click="add(index)" />
					</label>
				</span>
			</div>
		</section>
		<!-- 购买按钮 -->
		<section class="detailBottom">
			<span class="detailBottom_pric">
				<label for="">
					<font>总价</font>￥{{total_price}}
				</label>
			</span>
			<span class="" @click="goBuy">立即购买</span>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	import {
		Dialog,
		Toast
	} from 'vant'
	export default {
		name: 'groupPackage',
		components: {
			BackTo
		},
		data() {
			return {
				buyNum: [],
				id: '',
				packegeSelectIndex: 0,
				childIndex: 0,
				productList: [],
				productListPackage: [],
				model_date_f: [],
				dateSelectIndex: 0,
				defaultDate: new Date(),
				enrollsList: [],
				total_price: 0,
				time: ""
			}
		},
		created() {
			this.id = this.$route.query.id
			this.packegeSelectIndex = this.$route.query.packegeSelectIndex
			this.dateSelectIndex = this.$route.query.dateSelectIndex
		},
		mounted() {
			this.getData()
		},
		methods: {
			goBuy() {
				if (this.total_price == 0) {
					Toast('请选择购买数量');
					return
				}
				this.$router.push({
					path: '/person',
					query: {
						'id': this.id,
						'packegeSelectIndex': this.packegeSelectIndex,
						'time': this.time,
						'childIndex': this.childIndex,
						'buyNum': JSON.stringify(this.buyNum),
						'total_price': this.total_price
					}
				})
			},
			sub(e) {
				if (this.buyNum[e].num < 1) {
					this.buyNum[e].num = 0
				} else {
					this.buyNum[e].num = parseInt(this.buyNum[e].num) - 1
				}
				this.getTotal()
			},
			add(e) {
				if (this.buyNum[e].num >= this.enrollsList.remaining) {
					this.buyNum[e].num = this.enrollsList.remaining
				} else {
					this.buyNum[e].num = parseInt(this.buyNum[e].num) + 1
				}
				this.getTotal()
			},
			getTotal() {
				var total_price = 0
				this.enrollsList.enrolls.forEach((item, index) => {
					total_price = total_price + this.buyNum[index].num * parseFloat(item.price_01)
				});
				this.total_price = total_price
			},
			changes(index) {
				if (this.packegeSelectIndex == index) {
					return
				}
				this.packegeSelectIndex = index
				this.childIndex = 0
				this.dateSelectIndex = 0
				this.connectDate(this.productList.package)
				this.total_price = 0
			},
			change(index) {
				if (this.childIndex == index) {
					return
				}
				this.childIndex = index
				this.dateSelectIndex = 0
				this.connectDate(this.productList.package)
				this.total_price = 0
			},
			getData() {
				var jsonData = {
					packagecompany: "," + this.$platformid + ",",
					id: this.$route.query.id
				}
				this.$_post(
					this.$connectHttpDayun + '/team/api/teamgetfxwd', jsonData
				).then(res => {
					this.productList = res.object
					this.connectDate(res.object.package)
				})
			},
			// 操作 详情返回值
			connectDate(data) {
				let gctemplate = ''
				if (data[this.packegeSelectIndex].gctemplate.length == 0) {
					gctemplate = '0'
				} else {
					gctemplate = data[this.packegeSelectIndex].gctemplate[this.childIndex].id
				}

				var jsonData = {
					object: {
						packageID: data.length > 0 ? data[this.packegeSelectIndex].id : 0,
						gctemplate: gctemplate
					}
				}

				this.$_post(
					this.$connectHttpDayun + '/teamquery/get/wxapp/silist', jsonData
				).then(res => {
					console.log(res.objects)
					res.objects = res.objects.sort((a, b) => a.date - b.date)
					this.model_date_f = res.objects
					this.productListPackage = data[this.packegeSelectIndex]
					if (res.objects.length > 0) {
						// var data01 = {
						// 	count: 10,
						// 	date: 20220831,
						// 	dateFormat: "2022-08-31",
						// 	dateHous: 24,
						// 	day: 0,
						// 	endDate: 0,
						// 	enrolls: [{
						// 			enrollID: 1,
						// 			enrollName: "成人",
						// 			id: 76487,
						// 			isDeleted: 0,
						// 			planID: 66142,
						// 			price_01: 2580,
						// 			price_02: 2000,
						// 			price_03: 2000,
						// 			price_04: 0,
						// 			quota: 0
						// 		},
						// 		{
						// 			enrollID: 1,
						// 			enrollName: "成人01",
						// 			id: 76487,
						// 			isDeleted: 0,
						// 			planID: 66142,
						// 			price_01: 2380,
						// 			price_02: 2000,
						// 			price_03: 2000,
						// 			price_04: 0,
						// 			quota: 0
						// 		}
						// 	],
						// 	gctemplate: 0,
						// 	groupCode: "LDGT-20220831-私享山东",
						// 	id: 66142,
						// 	inventoryID: 63182,
						// 	isCheckSheet: 0,
						// 	occupancy: 0,
						// 	occupy: 0,
						// 	op: null,
						// 	orderChannel: 0,
						// 	orgID: 0,
						// 	packageID: 0,
						// 	packageName: "未命名套餐1",
						// 	refPrice: 0,
						// 	regimentType: 0,
						// 	remaining: 10,
						// 	remainingMax: 9,
						// 	scheduled: 0,
						// 	share: 2,
						// 	shareCN: "否",
						// 	startDate: 0,
						// 	teamID: 3112,
						// 	title: null,
						// 	week: "Wednesday"
						// }
						// this.enrollsList = data01
						this.enrollsList = res.objects[this.dateSelectIndex]
						var buyNum = []
						for (var i = 0; i < res.objects[this.dateSelectIndex].enrolls.length; i++) {
							buyNum.push({
								num: 0,
								info: []
							});
						}
						this.buyNum = buyNum

						this.defaultDate = new Date(res.objects[this.dateSelectIndex].dateFormat)
						this.time = res.objects[this.dateSelectIndex].dateFormat
					}

				})
			},
			select(e) {
				var list = this.model_date_f
				var time = this.formatDateTime(e)
				var data = list.filter(item => item.dateFormat == time)
				console.log(data)
				if (data.length > 0) {
					// this.total_price = this.buyNum * parseFloat(data[0].enrolls[0].price_01)
					this.enrollsList = data[0]
					this.getTotal()
					this.time = time
				} else {
					Dialog.alert({
						message: '暂无计划安排，请重新选择日期',
					}).then(() => {
						this.connectDate(this.productList.package)
						this.total_price = 0
						this.defaultDate = new Date()
						this.time = this.formatDateTime(new Date())
					});

				}

			},
			// 时间格式化
			formatDateTime(timestamp) {
				var date = new Date(timestamp);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				var minute = date.getMinutes();
				minute = minute < 10 ? ('0' + minute) : minute;
				var second = date.getSeconds();
				second = second < 10 ? ('0' + second) : second;
				// var Time = y + '-' + m + '-' + d + 'T' + h + ':' + minute + ':' + second;
				var Time = y + '-' + m + '-' + d;
				return Time
			},
			formatter(day) {
				const year = day.date.getFullYear();
				const month = day.date.getMonth() + 1;
				const date = day.date.getDate();
				if (this.model_date_f.length > 0) {
					this.model_date_f.forEach((e, index) => {
						var currentObj = new Date(Date.parse(e.dateFormat.replace(/-/g, "/")));
						if (year === currentObj.getFullYear()) {
							if (month === (currentObj.getMonth() + 1)) {
								if (date === currentObj.getDate()) {
									day.topInfo = currentObj.getDate()
									day.text = '余' + e.remaining
									day.bottomInfo = '￥' + e.enrolls[0].price_01 + '起'
								}
							}
						}
					});
				}
				return day
			}
		}
	}
</script>

<style>
	.groupPackage .choiceDate-calendar {
		height: 780px;
	}

	.groupPackage .van-calendar__header-title {
		text-align: left;
		font-size: 28px;
		color: #333;
		height: 80px;
		line-height: 80px;
		margin-left: 32px;
		font-weight: bold;
	}

	.groupPackage .van-calendar__header-subtitle {
		background-color: #fafafa;
	}

	.groupPackage .van-calendar__weekdays {
		background-color: #ff8a00;
		color: #fff;
	}

	.groupPackage .van-calendar__selected-day {
		background-color: rgba(255, 109, 0, .3);
		color: #ff6d00;
		justify-content: flex-end;
		text-align: right;
	}

	.groupPackage .van-calendar__bottom-info {
		color: #ff6d00;
		bottom: 5px
	}

	.groupPackage .van-calendar__day {
		transform: scale(0.8);
		font-size: 18px;
		color: #999;
		justify-content: flex-end;
		text-align: right;
		height: 106px;
	}

	.groupPackage .van-calendar__top-info {
		font-size: 34px;
		color: #333;
		transform: scale(1);
		top: 5px
	}

	.groupPackage-package {
		width: 100%;
		padding: 0 32px 20px 32px;
		box-sizing: border-box;
		border-bottom: 20px solid #f7f7f7;
	}

	.groupPackage-package h2 {
		font-size: 28px;
		padding: 30px 0 12px 0;
	}

	.groupPackage-package_con label {
		display: flex;
		flex-direction: column;
	}

	.groupPackage-package_con p {
		border-radius: 5px;
		text-align: center;
		font-size: 28px;
		color: #333;
		border: 1px solid #eeeeee;
		line-height: 64px;
		width: fit-content;
		padding: 0 32px;
		margin-top: 20px;
	}

	.groupPackageActive {
		border: 1px solid #ff6d00 !important;
		font-weight: bold;
	}

	.groupPackage-title {
		font-size: 28px;
		color: #333;
		height: 88px;
		line-height: 88px;
		margin-left: 32px;
	}

	.groupPackage-num {
		border-top: 20px solid #f7f7f7;
		padding-bottom: 160px;
	}

	.groupPackage-num_chosee {
		width: 100%;
		padding: 0 32px;
		box-sizing: border-box;
	}

	.groupPackage-num_chosee span {

		border-bottom: 1px solid #e6e6e6;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 30px 0;
	}

	.groupPackage-num_chosee span:first-child {
		border-top: 1px solid #e6e6e6;
	}

	.groupPackage-num_chosee label {
		display: flex;
		align-items: center;
		font-size: 28px;
		color: #333;
	}

	.groupPackage-num_chosee img {
		width: 40px;
		height: 40px;
	}

	.type-num-buynum {
		width: 96px;
		font-size: 28px;
		color: #333;
		text-align: center;
	}

	.groupPackage .detailBottom span {
		width: 50%;
	}

	.groupPackage .detailBottom_pric {
		background-color: #fff;
	}

	.groupPackage .detailBottom_pric label {

		font-size: 42px;
		font-weight: bold;
		color: #ff5663;
		display: flex;
		align-items: baseline;
	}

	.groupPackage .detailBottom_pric font {
		font-size: 24px;
		color: #333;
		font-weight: normal;
	}
</style>